import { DEFAULT_LOCALE } from 'shared/consts'
import store, { subscribe } from 'shared/store'
import { LOCK_UI, UNLOCK_UI } from 'shared/store/ducks/events'
import blockUI from 'views/assets/scripts/blockUI'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

const SELECTOR = '[data-clientside-hook~="OffersPageContainer"]'

/**
 * Mounts Offers on page load.
 * Binds loading overlay to the events that Offers emits while fetching.
 */
export default () => {
  const mountComponent = async container => {
    const {
      publicConfig: { locale = DEFAULT_LOCALE },
    } = store.getPublicRuntimeConfig()

    const i18n = await loadCatalogs(locale)
    const { default: hydrateComponent } = await import(
      /* webpackChunkName: "OffersContainerWithHydration", webpackPrefetch: true */
      './OffersContainerWithHydration'
    )

    hydrateComponent({
      i18n,
      container,
    })
  }

  const bindSubscriptions = () => {
    let unblockUI

    subscribe.after(LOCK_UI, () => {
      unblockUI = blockUI()
    })
    subscribe.after(UNLOCK_UI, () => {
      if (typeof unblockUI === 'function') {
        unblockUI()
      }
    })
  }

  const container = document.querySelector(SELECTOR)
  if (container) {
    mountComponent(container)
    bindSubscriptions()
  }
}
